'use client'

import type { ReactNode } from 'react'

import { useController } from 'react-hook-form'

import { cn } from '@/shared/lib/utils'
import { Checkbox } from '@/shared/ui/checkbox'
import { useFormField } from '@/shared/ui/form'

type FormCheckProps = {
  disabled?: boolean
  className?: string
  label?: ReactNode
}

export function FormCheck({ disabled, className, label }: FormCheckProps) {
  const { name } = useFormField()
  const { field } = useController({ name, disabled })

  return (
    <label className={cn('flex items-center gap-2 cursor-pointer', className)}>
      <Checkbox
        checked={!!field.value}
        onCheckedChange={field.onChange}
        disabled={disabled}
        ref={field.ref}
      />
      {label && <span className="text-sm">{label}</span>}
    </label>
  )
}
